import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MenuItem } from 'primeng/api';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthorizationService } from '../../authorization/authorization.service';
import { FeatureFlagService } from '../../core/feature-flags/feature-flag.service';
import { EnterpriseConfigurationDataAccessService } from '../../shared/modules/enterprise-configuration/enterprise-configuration-data-access.service';
import { AbstractHeader } from '../abstract-header';
import { AppWindow } from '../../AppWindow';

@Component({
  selector: 'app-authenticated-header',
  templateUrl: './authenticated-header.component.html',
  styleUrls: ['./authenticated-header.component.scss'],
})
export class AuthenticatedHeaderComponent extends AbstractHeader implements OnInit {
  public givenName$: Observable<any>;
  public isSigningOut: boolean = false;
  public changePasswordUrl?: string;
  public isNewOktaURLEnabled: boolean = false;
  public bodyItems: MenuItem[] = [{ label: 'Manage Users', url: '/uam' }];
  public copyrightItems: MenuItem[] = [
    { label: 'Legal', url: 'https://www.precisely.com/legal' },
    { label: 'Contact Sales', url: 'https://www.precisely.com/contact' },
  ];

  constructor(
    private _authorization: AuthorizationService,
    _enterpriseConfigurationService: EnterpriseConfigurationDataAccessService,
    _sanitizer: DomSanitizer,
    @Inject('window') private _window: AppWindow,
    private _featureFlagService: FeatureFlagService,
  ) {
    super(_enterpriseConfigurationService, _sanitizer);
    this.givenName$ = this._authorization.principal$.pipe(
      map((principal) => {
        if (!!principal && !!principal.identity && principal.identity.isAuthenticated) {
          return {
            firstName: principal.identity.givenName,
            lastName: principal.identity.familyName,
            email: principal.identity.email,
          };
        }
        return undefined;
      }),
    );

    this.changePasswordUrl = this._window.portalConfig.masterCardResetPasswordUrl;
  }

  async ngOnInit() {
    const features = await firstValueFrom(this._featureFlagService.getFeatures());
    if (features.mastercard_new_okta_url?.isEnabled) {
      this.isNewOktaURLEnabled = true;
    }
  }

  logout() {
    this._authorization.logout();
  }
  public onClick(){
    window.open("https://digital-trial-dev.onboarding.cloud.precisely.services/signup?moduleName=enrich", '_blank');
  }

  protected readonly Event = Event;
}
